import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PayCartIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M7.53999 18.5C6.19999 18.5 5.10999 19.59 5.10999 20.93C5.10999 22.27 6.19999 23.36 7.53999 23.36C8.87999 23.36 9.96999 22.27 9.96999 20.93C9.96999 19.59 8.87999 18.5 7.53999 18.5ZM7.53999 21.86C7.02999 21.86 6.60999 21.44 6.60999 20.93C6.60999 20.42 7.02999 20 7.53999 20C8.04999 20 8.46999 20.42 8.46999 20.93C8.46999 21.44 8.04999 21.86 7.53999 21.86Z"
        fill={color}
      />
      <path
        d="M17.6199 18.5C16.2799 18.5 15.1899 19.59 15.1899 20.93C15.1899 22.27 16.2799 23.36 17.6199 23.36C18.9599 23.36 20.0499 22.27 20.0499 20.93C20.0499 19.59 18.9599 18.5 17.6199 18.5ZM17.6199 21.86C17.1099 21.86 16.6899 21.44 16.6899 20.93C16.6899 20.42 17.1099 20 17.6199 20C18.1299 20 18.5499 20.42 18.5499 20.93C18.5499 21.44 18.1299 21.86 17.6199 21.86Z"
        fill={color}
      />
      <path
        d="M23.2099 5.31C22.8499 4.81 22.2599 4.5 21.6499 4.5H4.18995L3.89995 2.61C3.71995 1.9 3.01995 1.15 2.04995 1.15H0.819946C0.409946 1.14 0.0699463 1.48 0.0699463 1.89C0.0699463 2.3 0.409946 2.64 0.819946 2.64H2.04995C2.23995 2.64 2.40995 2.83 2.42995 2.9L4.22995 14.69C4.52995 16.17 5.74995 17.2 7.20995 17.2H19.8699C20.2799 17.2 20.6199 16.86 20.6199 16.45C20.6199 16.04 20.2799 15.7 19.8699 15.7H7.20995C6.46995 15.7 5.85995 15.18 5.70995 14.43L5.61995 13.84H20.0899C20.7999 13.84 21.5199 13.36 21.8799 12.64C21.9699 12.47 23.4299 7.12 23.4899 6.94C23.6699 6.4 23.5699 5.79 23.2199 5.3L23.2099 5.31ZM22.0499 6.5L20.5099 12.02C20.3899 12.21 20.2099 12.34 20.0899 12.34H5.38995L4.41995 6H21.6499C21.9699 6.04 22.1099 6.25 22.0499 6.5Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PayCartIcon.displayName = 'PayCartIcon';
